import React from "react";
import { Link } from "react-router";
import { AutoAffix } from "react-overlays";
import BrandLogoOrName from "./BrandLogoOrName";

const BrandHeader = ({ brand, affixedContainer }) => {
  return(
    <AutoAffix viewportOffsetTop={50} container={affixedContainer} affixClassName="panel panel-default" bottomClassName="panel panel-default">
      <div className="panel-default">
        <div className="panel-heading">
          <div className="pull-right">
            <Link to={"/car-seats/" + brand.key}
              className="btn btn-primary btn-sm">
              {brand.name} sizes &gt;
            </Link>
          </div>
          <BrandLogoOrName brand={brand} />
        </div>
      </div>
    </AutoAffix>
  );
};

BrandHeader.propTypes = {
  brand: React.PropTypes.object.isRequired,
  affixedContainer: React.PropTypes.object
};

export default BrandHeader;



/** WEBPACK FOOTER **
 ** ./src/components/AvailableSizes/CarSeatsContainer/Brands/BrandHeader.js
 **/